// extracted by mini-css-extract-plugin
module.exports = {"titol":"TitolHeader_titol__2uyx9"};